import PageShell from "../components/PageShell";
import { viewsFor } from "../content/views";
import seoPages from "../content/seo-pages.json";

const views = viewsFor("about");
const seo = seoPages["/about"];

export default function About() {
  return (
    <PageShell
      title={seo.title}
      description={seo.description}
      bodyClass="on-light"
      dataFrame={null}
      views={views}
    />
  );
}
